export default __webpack_public_path__ + "static/media/bellinati-perez.7180d990.svg";